module.exports = __webpack_public_path__ + "img/ico-email--yellow.db44548e.svg";